// import lazyLoading from '../lazyLoading';

export default {
  name: 'tutorials',
  caption: 'Tutorials',
  wdm16_id: '',
  icon: 'icon-speech',
  path: '/tutorials',
  // component: lazyLoading('patient/index'),
  required: [],
  permissions: [],
  meta: {
    required: [],
    icon: 'fa-bars',
    expanded: false
  }
};
